import Vue from 'vue'
import Slider from '../models/Slider'

// actions
export const actions = {
  async fetchSliders ({ commit }) {
    try {
      const sliders = await Slider.include('media').get()
      return sliders.data
    } catch (err) {
      if (process.client) {
        Vue.notify({
          group: 'general',
          type: 'error',
          text: this.app.i18n.t('not_found')
        })
      }
    }
  }
}
